import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { HeaderLogoAndTel } from "../../../components/HeaderLogoAndTel";
import { FooterFull } from "../../../components/FooterFull";
import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { TaxDeduction } from "../../../components/TaxDeduction";
import { Modal } from "../../../components/Modal";
import { AdvanceNoRocket } from "../../../components/AdvanceNoRocket";
import { ExpertLicenses } from "../../../components/ExpertLicenses";
import { Licenses } from "../../../components/Licenses";
import { SmiAboutUs } from "../../../components/SmiAboutUs";

import * as main from "./styles/main.module.scss";
import * as screen1 from "./styles/screen1.module.scss";
import * as content from "./styles/content.module.scss";
import * as process from "./styles/process.module.scss";
import * as lesson from "./styles/lesson.module.scss";
import * as speaker from "./styles/speaker.module.scss";
import * as cost from "./styles/cost.module.scss";
import * as reviews from "./styles/reviews.module.scss";
import * as advance from "./styles/advance.module.scss";
import dataReviews from "./data/reviews.json";

const Screen1 = () => {
  return (
    <header className={screen1.screen1}>
      <div className="container">

        <HeaderLogoAndTel logo={"orange"} phoneColor={"#fff"}/>
        <p>Онлайн-курс</p>
        <h1>
          Фонетика <br/>английского языка
        </h1>


        <div className={`${main.btnBlock} ${screen1.btn}`}>
          <a href="#process" className={main.blockBtn}>Подробнее</a>
        </div>

      </div>
    </header>
  );
};
const Content = () => {
  return (
    <section className={content.content}>
      <div className="container">

        <h2 className={main.mainTitle}>Что вас ждет в этом онлайн-курсе?</h2>

        <div className={`row ${content.row}`}>
          <div className={`col col-12 col-lg-4 ${content.col}`}>
            <div className={content.item}>
              <div className={content.icon}>
                <img src="https://fs.advance.ru/landing-pages/online/fonetika_angliyskogo_yazyka/icon-phonetic-1.png" alt=""/>
              </div>
              <h3>
                Будете учиться там, <br/> где удобно вам
              </h3>
              <p>
                22 урока в любое время в любом месте
              </p>
            </div>
          </div>

          <div className={`col col-12 col-lg-4 ${content.col}`}>
            <div className={content.item}>
              <div className={content.icon}>
                <img src="https://fs.advance.ru/landing-pages/online/fonetika_angliyskogo_yazyka/icon-phonetic-2.png" alt=""/>
              </div>
              <h3>
                Узнаете как говорить правильно и&nbsp;почему
              </h3>
              <p>
                Каждый модуль с практикой и закреплением звуков и букв
              </p>
            </div>
          </div>

          <div className={`col col-12 col-lg-4 ${content.col}`}>
            <div className={content.item}>
              <div className={content.icon}>
                <img src="https://fs.advance.ru/landing-pages/online/fonetika_angliyskogo_yazyka/icon-phonetic-3.png" alt=""/>
              </div>
              <h3>
                Вам не придется заставлять себя учиться
              </h3>
              <p>
                Последовательные модули и увлекательные упражнения помогут поддерживать мотивацию
              </p>
            </div>
          </div>

          <div className={`col col-12 col-lg-4 offset-lg-2 ${content.col}`}>
            <div className={content.item}>
              <div className={content.icon}>
                <img src="https://fs.advance.ru/landing-pages/online/fonetika_angliyskogo_yazyka/icon-phonetic-4.png" alt=""/>
              </div>
              <h3>
                Отработаете полученные&nbsp;знания
              </h3>
              <p>
                С помощью специальных тренажеров
              </p>
            </div>
          </div>

          <div className={`col col-12 col-lg-4 ${content.col}`}>
            <div className={content.item}>
              <div className={content.icon}>
                <img src="https://fs.advance.ru/landing-pages/online/fonetika_angliyskogo_yazyka/icon-phonetic-5.png" alt=""/>
              </div>
              <h3>
                Вся фонетика английского языка
              </h3>
              <p>
                За выходные
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
const Process = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={process.process} id="process">
      <div className="container">

        <h2 className={main.mainTitle}>
          Что будем проходить на&nbsp;курсе:
        </h2>

        <div className="row">
          <div className={`col col-12 col-lg-3 ${process.col}`}>
            <div className={process.item}>
              <div className={process.icon}>
                <img src="https://fs.advance.ru/landing-pages/online/fonetika_angliyskogo_yazyka/kursphonetic-1.png" alt=""/>
              </div>
              <p>
                <span>Произношение</span>
                Буквы и звуки, правила чтения согласных и&nbsp;гласных звуков
              </p>
            </div>
          </div>

          <div className={`col col-12 col-lg-3 ${process.col}`}>
            <div className={process.item}>
              <div className={process.icon}>
                <img src="https://fs.advance.ru/landing-pages/online/fonetika_angliyskogo_yazyka/kursphonetic-2.png" alt=""/>
              </div>
              <p>
                <span>Чтение</span>
                гласных звуков, разные
                особенности и&nbsp;сочетания гласных,
                чтение безударных
                и&nbsp;ударных гласных
              </p>
            </div>
          </div>

          <div className={`col col-12 col-lg-3 ${process.col}`}>
            <div className={process.item}>
              <div className={process.icon}>
                <img src="https://fs.advance.ru/landing-pages/online/fonetika_angliyskogo_yazyka/kursphonetic-3.png" alt=""/>
              </div>
              <p>
                <span>Транскрипция</span>
                Запись звучания буквы или&nbsp;слова
                в&nbsp;виде последовательности
                специальных фонетических
                символов, транскрипционные
                знаки
              </p>
            </div>
          </div>

          <div className={`col col-12 col-lg-3 ${process.col}`}>
            <div className={process.item}>
              <div className={process.icon}>
                <img src="https://fs.advance.ru/landing-pages/online/fonetika_angliyskogo_yazyka/kursphonetic-4.png" alt=""/>
              </div>
              <p>
                <span>Правила артикуляции</span>
                Узнаете как&nbsp;произносить тот или&nbsp;иной звук, а&nbsp;также положение языка, губ, формы&nbsp;рта при&nbsp;их&nbsp;произношении
              </p>
            </div>
          </div>
        </div>

        <div className={`${main.btnBlock} ${process.btn}`}>
          <button className={main.blockBtn} onClick={()=>{setShowModal(true)}}>
            Купить курс
          </button>
          <TaxDeduction margin={"30px 0 0"}/>
        </div>

      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
const Lesson = () => {
  return (
    <section className={lesson.lesson}>
      <div className="container">
        <h2 className={main.mainTitle}>Курс содержит 22&nbsp;урока, в&nbsp;каждом из&nbsp;которых:</h2>

        <div className="row">
          <div className={`col col-12 col-lg-4 ${lesson.col}`}>
            <div className={lesson.item}>
              <div className={lesson.icon}>
                <img src="https://fs.advance.ru/landing-pages/online/fonetika_angliyskogo_yazyka/soderzhanie1.png" alt=""/>
              </div>
              <p>
                Каждый звук буквы проговаривается преподавателем
              </p>
            </div>
          </div>

          <div className={`col col-12 col-lg-4 ${lesson.col}`}>
            <div className={lesson.item}>
              <div className={lesson.icon}>
                <img src="https://fs.advance.ru/landing-pages/online/fonetika_angliyskogo_yazyka/soderzhanie2.png" alt=""/>
              </div>
              <p>
                Любой звук можно повторить и проговорить
              </p>
            </div>
          </div>

          <div className={`col col-12 col-lg-4 ${lesson.col}`}>
            <div className={lesson.item}>
              <div className={lesson.icon}>
                <img src="https://fs.advance.ru/landing-pages/online/fonetika_angliyskogo_yazyka/soderzhanie3.png" alt=""/>
              </div>
              <p>
                Специальные тренажеры позволят закрепить информацию
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
const Speaker = () => {
  return (
    <section className={speaker.speaker}>
      <div className="container">
        <div className={`row ${speaker.row}`}>
          <div className="col-12 col-lg-5">
            <img src="https://fs.advance.ru/landing-pages/online/fonetika_angliyskogo_yazyka/speaker.png" alt="Анна Савельева"/>
          </div>
          <div className="col-12 col-lg-7">
            <h2>Спикер&nbsp;— ведущий преподаватель английского языка
              в&nbsp;Advance</h2>
            <p className={speaker.name}>Анна Савельева</p>
            <ul>
              <li>Магистр лингвистики (СПбГУ);</li>
              <li>Эксперт по подготовке к&nbsp;ЕГЭ и&nbsp;IELTS;</li>
              <li>Соавтор онлайн-курса «Английский за&nbsp;3&nbsp;месяца»;</li>
              <li>Ведущая онлайн-курсов: «Активный английский», «Английский для&nbsp;ваших целей»;</li>
              <li>За 1&nbsp;день выучила 1000&nbsp;французских слов.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
const Cost = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={cost.cost} id="action">
      <div className="container">

        <h2>Онлайн-курс <br/> Фонетика английского языка</h2>

        <p className={cost.oldcost}>8000&nbsp;₽</p>
        <p className={cost.newcost}>5900&nbsp;₽</p>


        <div className={`${main.btnBlock} ${cost.btn}`}>
          <button className={main.blockBtn} onClick={()=>{setShowModal(true)}}>Купить курс</button>
          <TaxDeduction margin={"30px 0 0"}/>
        </div>

      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
const Reviews = () => {
  const swiperEl = React.useRef();
  React.useEffect(() => {
    if (swiperEl.current) {
      Object.assign(swiperEl.current, {
        slidesPerView: 1,
        autoHeight: true,
        grabCursor: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
      swiperEl.current.initialize();
    }
  }, []);
  return (
    <section className={reviews.reviews}>
      <div className="container">
        <h2 className={main.mainTitle}>Отзывы</h2>
        <swiper-wrapper>
          <swiper-container ref={swiperEl} init="false">
            {
              dataReviews.map((elem, index) => (
                <swiper-slide key={index}>
                  <img src={elem.avatar} alt={elem.author}/>
                  <p>{elem.text}</p>
                  <h3 className={reviews.name}>{elem.author}</h3>
                </swiper-slide>
              ))
            }
          </swiper-container>
          <div
            className="swiper-pagination"
            style={{
              "--swiper-pagination-bullet-size": "15px",
              "--swiper-pagination-color": '#002b58',
              position: "unset"
            }}
          />
          <div className="swiper-button-prev" style={{"--swiper-navigation-color": "#C6C6C6"}}></div>
          <div className="swiper-button-next" style={{"--swiper-navigation-color": "#C6C6C6"}}></div>
        </swiper-wrapper>
      </div>

    </section>
  );
};
const Advance = () => {
  return (
    <>
      <AdvanceNoRocket
        sectionName={advance.noRocket}
        ttlName={advance.title}
        colCustomize={`col ${advance.noRocketCol}`}
        yearsTxt={"учим людей раскрывать и развивать свой интеллектуальный потенциал, повышать личную эффективность"}
        pplCountTxt={"человек приняли участие в наших курсах и семинарах"}
        pplCoursesTxt={"человек прошли наши полные курсы"}
      />
      <section className={advance.advance}>
        <div className="container">
          <h2 className={advance.title}>Нас ценят эксперты образования</h2>
          <ExpertLicenses navColor={"#002b58"} subTitleColor={"#002b58"}/>
        </div>
      </section>
      <section className={`${advance.advance} ${advance.advanceDevelop}`}>
        <div className="container">
          <h2 className={advance.title}>Мы развиваем образование</h2>
          <Licenses navColor={"#FFF"}/>
        </div>
      </section>
      <SmiAboutUs
        sectionName={advance.smi}
        ttlName={advance.title}
      />
    </>
  );
};

const TITLE = 'Как быстро выучить и запомнить карту мира | Онлайн-курс "Глобус на пальце" от центра Advance';
const DESCRIPTION = 'Онлайн-курс "Глобус на пальце" | Центр образовательных технологий Advance ✅ Уникальные методики обучения ☝️ Заходите!';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget=<GetCourseWidget hash={'ec23cc657be041b3a8b1f3196eefb611033e21cf'} id={'206667'}/> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ fontFamily: `"Montserrat", sans-serif`, fontSize: "18px", color: '#fff' }}>
      <Screen1/>
      <Content/>
      <Process widget={widget}/>
      <Lesson/>
      <Speaker/>
      <Cost widget={widget}/>
      <Reviews/>
      <Advance/>
    </main>

    <FooterFull/>
  </DefaultLayout>
);
export default Page;
